import http from "./http.js";

async function getBonus(id) {
  try {
    const response = await http.get(`bonuses/${id}`);
    return {
      date: response.data.date,
      amount: response.data.amount,
      comments: response.data.comments,
      hours: response.data.hours,
      client: {
        id: response.data.client.id,
        title: response.data.client.title,
      },
      project: response.data.project
        ? {
          id: response.data.project.id,
          title: response.data.project.title,
        }
        : null,
    };
  } catch (err) {
    throw err;
  }
}

async function updateBonus(id, bonus) {
  try {
    const response = await http.put(`bonuses/${id}`, bonus);
    return response;
  } catch (err) {
    throw err;
  }
}

async function createBonus(bonus) {
  try {
    const response = await http.post("bonuses", bonus);
    return response;
  } catch (err) {
    throw err;
  }
}

async function getBonuses(page = 1, rowsPerPage = 9, search = "", filter = "") {
  try {
    const response = await http.get(
      `bonuses?page=${page}&pageSize=${rowsPerPage}&searchTerm=${search}${filter}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

export { getBonus, updateBonus, createBonus, getBonuses };
